import useTranslation from "../CustomHooks/useTranslation";
import Image from "../images/Image";
import { emptyScreenContent } from "./EmptyScreenContent";

interface EmptyListingScreenProps {
  emptyScreenText: {
    heading1: string;
    heading2?: string;
    img?: string;
  };
  imageHight?: string;
}

export default function EmptyListingScreen({
  emptyScreenText,
  imageHight
}: EmptyListingScreenProps) {
  const { translate } = useTranslation(emptyScreenContent);
  return (
    // h-fit rather than a fixed height: the illustration and headings are taller than
    // any fixed value, so a fixed height overflows once the page is zoomed.
    <div className="flex flex-col items-center justify-center p-4 h-fit max-w-full">
      {/* Image container */}
      <Image
        src={emptyScreenText.img || "empty_screen_img"}
        // The illustration is 496x350 intrinsic, so it is capped to stay within the
        // card at higher zoom levels rather than pushing the copy out of view.
        className={`${imageHight || 'max-h-[45vh]'} w-fit max-w-full object-contain`}
        testId="empty-screen-image"
      />
      {/* Heading */}
      <h1 className="text-heading3 text-primary_text text-center pt-5 pb-1 text-base sm:text-lg md:text-xl lg:text-2xl">
        {translate(emptyScreenText.heading1)}
      </h1>
      {/* Subheading */}
     {emptyScreenText.heading2 && <p className="text-secondary_text text-body2 text-center text-sm sm:text-base md:text-lg">
        {translate(emptyScreenText.heading2)}
      </p>}
    </div>
  );
}
